import type { Theme } from '../content/themes';

/**
 * כותב את צבעי הערכה כמשתני CSS על שורש המסמך.
 *
 * הכיוון הזה — מהאובייקט אל ה-CSS — הוא מכוון: הקנבס קורא את אותו אובייקט ישירות,
 * ולכן ה-HUD ושדה הקרב לא יכולים להתפצל לשתי ערכות שונות.
 */
export function applyTheme(theme: Theme): void {
    const root = document.documentElement;
    for (const [key, value] of Object.entries(theme.colors)) {
        root.style.setProperty(`--cf-${key}`, value);
    }
    theme.playerColors.forEach((color, i) => {
        root.style.setProperty(`--cf-player-${i}`, color);
    });
}
